<div class="modal-header">
    <div class="row col-12">
        <div class="modal-title col-10">
            <h3>Administrator Adgang</h3>
        </div>
        <div class="col-2 align-self-center">
            <div class="text-end">
                <button type="button" class="btn" aria-label="Close" (click)="activeModal.dismiss('Cross click')">
                    <span aria-hidden="true"><i class="fa-solid fa-x"></i></span>
                </button>
            </div>
        </div>
    </div>
</div>

<div class="modal-body col-12" style="height: 80vh; position: relative;">
    <!-- Loading Overlay -->
    @if(isEmployeesLoading())
    {
    <div class="loading-overlay">
        <div class="d-flex flex-column justify-content-center align-items-center">
            <div class="continuous-loader" role="status"></div>
            <h4 class="mt-3">Indlæser medarbejdere</h4>
        </div>
    </div>
    }

    @if(!isEmployeesLoading())
    {
    <div class="selected-admins-table" [style.height.px]="selectedAdminsTableHeight()">
        <table class="table table-hover table-striped mb-1">
            @if(selectedAdmins().length === 0 && systemAdmins().length === 0)
            {
            <thead>
                <tr>
                    <th class="ms-2 no-data">Ingen medarbejdere har administrator adgang.</th>
                </tr>
            </thead>
            }
            @else
            {
            <thead class="thead-sticky">
                <tr>
                    <th scope="col"> Navn </th>
                    <th scope="col"> E-mail </th>
                    <th scope="col"> Afdeling</th>
                    <th scope="col"> Giv Adgang </th>
                </tr>
            </thead>
            }

            <tbody>
                <!-- Selected Admins (can be toggled) -->
                @for (item of selectedAdmins(); track item.id)
                {
                <tr>
                    <td scope="row">{{ item.name }} </td>
                    <td scope="row">{{ item.email }}</td>
                    <td scope="row">{{ item.departmentName }} - [{{ item.departmentCode }}] </td>
                    <td scope="row" (click)="toggleSelection(item)" role="button">
                        <div class="form-check form-switch d-flex justify-content-center" style="pointer-events: none;">
                            <input class="form-check-input" type="checkbox" checked="true">
                        </div>
                    </td>
                </tr>
                }

                <!-- System Admins Divider -->
                @if(systemAdmins().length > 0)
                {
                <tr class="table-light">
                    <td colspan="4" class="py-2">
                        <div class="d-flex align-items-center">
                            <hr class="flex-grow-1 me-3">
                            <small class="text-muted fw-bold">Crono Administratorer</small>
                            <i title="Crono administratorer kan ikke fjernes fra denne liste. De har permanent adgang til systemet."
                                class="fa-circle-question fa-light info-icon ms-2"></i>
                            <hr class="flex-grow-1 ms-3">
                        </div>
                    </td>
                </tr>
                }

                <!-- System Admins (cannot be toggled) -->
                @for (item of systemAdmins(); track item.id)
                {
                <tr class="table-secondary">
                    <td scope="row">{{ item.name }} <i class="fa-solid fa-user-shield text-primary ms-1"
                            title="Crono Administratorer"></i></td>
                    <td scope="row">{{ item.email }}</td>
                    <td scope="row">{{ item.departmentName }} - [{{ item.departmentCode }}] </td>
                    <td scope="row">
                        <div class="form-check form-switch d-flex justify-content-center">
                            <input class="form-check-input" type="checkbox" checked="true" disabled>
                        </div>
                    </td>
                </tr>
                }
            </tbody>
        </table>
    </div>

    <!-- Resize Bar -->
    <div class="resize-bar mb-3" (mousedown)="onResizeStart($event)">
        <i class="fa-solid fa-arrows-up-down"></i>
    </div>


    <div class="row mt-1">
        <!-- Search Field -->
        <div class="col-6">
            <app-search-input 
                [placeholder]="'Søg medarbejdere...'"
                [autofocus]="true"
                [(searchText)]="searchText"
                [items]="availableEmployees()"
                [searchFields]="['name', 'email', 'departmentCode', 'departmentName']"
                (filteredItemsChange)="onFilteredEmployeesChange($event)">
            </app-search-input>
        </div>
    </div>

    <!-- Employees List Table -->
    <div class="available-employees-table mt-2" [style.height.px]="availableEmployeesTableHeight()">
        <div class="table table-hover table-striped">
            @if(filteredEmployees().length === 0)
            {
            <thead>
                <tr>
                    <th class="ms-2 no-data">Ingen medarbejdere at vise.</th>
                </tr>
            </thead>
            }
            @else
            {
            <table class="table table-hover table-striped">
                <thead class="thead-sticky">
                    <tr>
                        <th scope="col"> Navn </th>
                        <th scope="col"> E-mail </th>
                        <th scope="col"> Afdeling</th>
                        <th class="text-nowrap" scope="col"> Giv Adgang </th>
                    </tr>
                </thead>


                <tbody>
                    <!-- For Each Employee (excluding all admins) -->
                    @for (item of filteredEmployees(); track item.id)
                    {
                    <tr>
                        <td scope="row">{{ item.name }} </td>
                        <td scope="row">{{ item.email }}</td>
                        <td scope="row">{{ item.departmentName }} - [{{ item.departmentCode }}] </td>
                        <td scope="row" (click)="toggleSelection(item)" role="button">
                            <div class="form-check form-switch d-flex justify-content-center"
                                style="pointer-events: none;">
                                <input class="form-check-input" type="checkbox" [checked]="false">
                            </div>
                        </td>
                    </tr>
                    }
                </tbody>
            </table>
            }
        </div>
    </div>
    }
</div>
<div class="modal-footer bg-transparent d-flex justify-content-between align-items-center">
    <div class="d-flex gap-2">
        <div>
            <h5 class="text-nowrap" style="margin-top: 1px;">Crono Administratorer <i
                    class="fa-light fa-circle-question info-icon"
                    title="Disse afdelinger vil altid blive oprettet som Crono Administrator for en kunde."></i>
                :</h5>
        </div>
        <div class="d-flex gap-2">
            @if (systemAdminInfo().length !== 0) {
            @for (info of systemAdminInfo(); track info.departmentCode) {
            <div [title]="info.names.join('\n')" class="department-badge">
                {{info.departmentCode}}
            </div>
            }
            }
        </div>
    </div>
    <button class="btn btn-success" (click)="save()" [disabled]="waitingNetworkResponse()">
        @if(waitingNetworkResponse()) {
        <div class="spinner-border spinner-border-sm me-2" role="status">
            <span class="visually-hidden">Gemmer...</span>
        </div>
        }
        Gem
    </button>
</div>